import styles from "./StatsPanel.module.scss";
import currencySmallIcon from "../../icons/currency-small.png";
import { Level } from "./Level/Level";
import { Faq } from "./Faq/Faq";
import { Balance } from "./Balance/Balance";
import { useDispatch, useSelector } from "../../hooks";
import { NotEnoughMoney } from "../Popup/NotEnoughMoney/NotEnoughMoney";
import { setBalanceError, setTicketsBalanceError } from "../../redux/user";
import { Tickets } from "../TicketsPanel/Tickets";
import { Splitter } from "./Splitter/Splitter";
import { NotEnoughTickets } from "../Popup/NotEnoughMoney/NotEnoughTickets";
import { ChallengeButton } from "./ChallengeButton/ChallengeButton";
import { shortNumberForm } from "../../utils/numbers";
import { Fragment } from "../Fragment/Fragment";
import { Tooltip } from "@mui/material";

const ticketsData = [
    { color: 'Серые', type: 'обычных' },
    { color: 'Синие', type: 'редких' },
    { color: 'Фиолетовые', type: 'эпических' },
    { color: 'Желтые', type: 'легендарных' },
];

export const StatsPanel = () => {
    const { profit, balanceError, ticketsBalanceError, tickets } = useSelector(store => store.user.info);
    const { fragments } = useSelector(store => store.draws);
    const dispatch = useDispatch();
    
    const handleClose = () => {
        dispatch(setBalanceError(''));
    }

    const handleTicketsClose = () => {
        dispatch(setTicketsBalanceError(null));
    }

    const getTicketsTooltips = () => ticketsData.map(item => `${item.color} билеты нужны для участия в ${item.type} розыгрышах`);

    return (
        <div className={styles.statsPanel}>
            <div className={styles.topRow}>
                <div className={styles.topLeftBlock}>
                    <Level />

                    <div className={styles.currency}>
                        <div className={styles.balance}>
                            <img src={currencySmallIcon} className={styles.icon} alt="balace currency" />
                            <Balance />
                        </div>

                        <div className={styles.income}>
                            <span>{`(+${shortNumberForm(profit, 1)} в час)`}</span>
                        </div>
                    </div>

                    <Tooltip 
                        title={'Соберите 50 фрагментов и получите сертификат Wildberries на 500 руб.'}
                        arrow
                        enterTouchDelay={0}
                        leaveTouchDelay={4000}
                        classes={{
                            tooltip: `${styles.tooltip} ${styles.body}`,
                            arrow: `${styles.tooltip} ${styles.arrow}`,
                        }}
                        slotProps={{
                            popper: {
                            modifiers: [
                                {
                                name: 'offset',
                                options: {
                                    offset: [0, -14],
                                },
                                },
                            ],
                            },
                        }}
                    >
                        <div className={styles.fragments}>
                            <div className={styles.balance}>
                                <Fragment />
                                {`${fragments} из 50`}
                            </div>

                            <div className={styles.income}>
                                <span>{`(${Math.min(100, Math.round(fragments / 50 * 100))}%)`}</span>
                            </div>
                        </div>
                    </Tooltip>
                </div>
                
                <div className={styles.topRightBlock}>
                    <Faq />
                    <ChallengeButton />
                </div>
            </div>

            <Splitter />
            <Tickets { ...tickets } context='header' tooltips={ getTicketsTooltips() } />

            { balanceError &&
                <NotEnoughMoney textNode={ balanceError } onClose={ handleClose } />
            }

            { ticketsBalanceError &&
                <NotEnoughTickets
                    ticketType={ ticketsBalanceError.ticketType }
                    needAmount={ ticketsBalanceError.amount }
                    onClose={ handleTicketsClose }
                />
            }
        </div>
    );
}
